import { styled } from 'styled-components';
import { Theme, Typography, Utils } from 'team-hero-ui';

const { flexFn, pxToRem } = Utils;

export const ItemStyled = styled.div`
  ${flexFn('center', 'start', 'column')};
  width: 100%;
`;

export const ContentWrapperStyled = styled.div`
  ${flexFn('center', 'start', 'column')};
  gap: ${pxToRem(16)};
  height: 100%;
`;

export const HeadlineStyled = styled(Typography.H1)`
  text-transform: uppercase;
  color: ${Theme.colors.primary.grey};
`;

export const SubHeadlineStyled = styled(Typography.H2)`
  color: ${Theme.colors.primary.grey};
  font-weight: 600;
  text-transform: uppercase;
`;

export const DescriptionStyled = styled.p`
  color: ${Theme.colors.primary.grey};
  font-size: ${pxToRem(12)};
`;
